module.exports = __webpack_public_path__ + "img/download_apple.742eca0f.png";